/**
 * @desc
 * - displays an icon that shows a different color indicating online/offline presence
 * - displays a tooltip on mouseover with details about presence
 */
;(function () {
  angular
    .module('contrast.presence')
    .directive('csPresenceIndicator', ['presenceStatuses', csPresenceIndicator])

  function csPresenceIndicator(presenceStatuses) {
    return {
      restrict: 'E',
      scope: {
        status: '@',
        tooltipCase: '@',
        lastActivity: '@',
        format: '@'
      },
      templateUrl: 'views/csPresenceIndicator/cs-presence-indicator.html',
      controller: 'csPresenceIndicatorCtrl',
      controllerAs: 'presenceCtrl',
      link: function (scope, element, attrs, controller) {
        if (!statusIsValid(scope.status)) {
          throw new Error(
            'status is required and must be a string equal to "' +
              presenceStatuses.online +
              '" or "' +
              presenceStatuses.offline +
              '"'
          )
        }
        if (!angular.isString(scope.tooltipCase)) {
          scope.tooltipCase = 'verbose'
        }
        controller.activate(scope)
      }
    }

    function statusIsValid(status) {
      return (
        angular.isString(status) &&
        (status.toLowerCase() == presenceStatuses.online ||
          status.toLowerCase() == presenceStatuses.offline)
      )
    }
  }
}).call(this)
